import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CheckIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SearchFilter } from 'components/meetings';
import { MATCH_ATTENDEE, MATCH_MEETING, MATCH_TRANSCRIPT } from '../constants';
import { SortSelector } from './sort_selector';
import { Search } from '../input/search';
const buttonSelectedCss = "b1dyv1b4";
const buttonCss = "b1tz35x2";
const Button = forwardRef((props, ref) => {
  const {
    selected,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(buttonCss, {
    [buttonSelectedCss]: selected
  }, props.className)} />;
});
const containerCss = "cxx7obz";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const searchInputContainerIsPhoneCss = "ssuq4r7";
const searchInputContainerCss = "sv8s927";
const SearchInputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(searchInputContainerCss, {
    [searchInputContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const rowJustifyBetweenCss = "r1qcujua";
const rowRelativeCss = "r1uffa8r";
const rowCss = "r1ou5iet";
const Row = forwardRef((props, ref) => {
  const {
    justifyBetween,
    relative,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, {
    [rowJustifyBetweenCss]: justifyBetween,
    [rowRelativeCss]: relative
  }, props.className)} />;
});
const QuickFilterButton = ({
  type,
  filters,
  setFilters,
  children
}) => {
  const {
    searchIn
  } = filters;
  const enabled = searchIn.includes(type);
  const toggle = filter => {
    const newFilters = searchIn.includes(filter) ? searchIn.filter(f => f !== filter) : [...searchIn, filter];
    setFilters({
      ...filters,
      searchIn: newFilters
    });
  };
  return <Button selected={enabled} onClick={() => toggle(type)}>
      {enabled && <CheckIcon />}
      {children}
    </Button>;
};
export const Header = ({
  searchQuery,
  filters,
  setFilters,
  sortOrder,
  setSortOrder,
  onSuggestionClick
}) => <Container>
    <Row justifyBetween>
      <Row relative>
        <SearchInputContainer>
          <Search initialValue={searchQuery} onSuggestionClick={onSuggestionClick} location="meetings_search_results" searchFilters={filters} />
        </SearchInputContainer>
        <SearchFilter filters={filters} setFilters={setFilters} searchQuery={searchQuery} />
      </Row>
      <SortSelector value={sortOrder} onChange={setSortOrder} />
    </Row>
    <Row>
      <QuickFilterButton type={MATCH_MEETING} filters={filters} setFilters={setFilters}>
        {I18n.t('publisher.meetings.search.results.filters.meetings')}
      </QuickFilterButton>
      <QuickFilterButton type={MATCH_TRANSCRIPT} filters={filters} setFilters={setFilters}>
        {I18n.t('publisher.meetings.search.results.filters.transcripts')}
      </QuickFilterButton>
      <QuickFilterButton type={MATCH_ATTENDEE} filters={filters} setFilters={setFilters}>
        {I18n.t('publisher.meetings.search.results.filters.attendees')}
      </QuickFilterButton>
    </Row>
  </Container>;

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");